import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import service  from './util/network'
import './assets/css/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import "./bus/bus";
// 在main.js中全局引入
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)

Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

Vue.use(Vant)

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import vueEsign from "vue-esign";
Vue.use(vueEsign);

Vue.prototype.$axios = service


const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
